import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Table, Button, Badge } from 'antd';
import moment from 'moment'
import { SyncOutlined } from '@ant-design/icons';
@inject('streamManagementStore')
@observer
class SearchResult extends Component {
  handleRestart = (record) => {
    const { streamManagementStore } = this.props
    streamManagementStore.onRestartStreamAction(record.dag_id)
  }
  handlePageChange = (page, pageSize) => {
    const { streamManagementStore } = this.props;
    streamManagementStore.onChangePageNumAction(page, pageSize);
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { streamManagementStore } = this.props
    const { dataList, stateList } = streamManagementStore
      return (
        <>
          <Table className='searchResult' dataSource={toJS(dataList)} pagination={false} rowClassName={this.getRowClassName} rowKey='dag_id' bordered>
              <Table.Column title='Stream Name' dataIndex="dag_id" key="dag_id" ellipsis={true} />
              <Table.Column title='Status' dataIndex="state" key="state"
                  onFilter={(value, record) => record.state.indexOf(value) === 0}
                  filters={stateList}
                            render={(text=> <Badge color={text === 'success' ? '#00b578' : text === 'failed' ? '#ff3b30' : text === 'running' ? 'rgb(154,219,231)':'#00b7f4'} text={text}/>)}
              />
              <Table.Column title='Start Time' dataIndex="start_date" key="start_date" render={(text,record) =>(text!==null?moment(text).format('YYYY-MM-DD HH:mm:ss'):null)} />
              <Table.Column align='center' title="Action" key="Action" render={(text, record) => (
                <>
                  <Button type='link' onClick={() => this.handleRestart(record)} icon={<SyncOutlined />} title='Restart' />
                </>
              )}/>
          </Table>
        </>
      );
  }
}

export default SearchResult;
